import { createSlice } from "@reduxjs/toolkit";
import { getUserHistories } from "./HistoryActions";

const initialState = {
    loading: false,
    userHistories: [],
    error: null,
    success: false, // for monitoring the registration process.
  }

const HistorySlice = createSlice({
    name: "HistorySlice",
    initialState,
    reducers: {},
    extraReducers:{
        [getUserHistories.fulfilled]: (state, {payload}) => {
            state.loading = false
            state.success = true
            state.userHistories = payload.data
        },
        [getUserHistories.pending]: (state, {payload}) => {
            state.loading = true
        },
        [getUserHistories.rejected]: (state, {payload}) => {
            state.loading = false
            state.userHistories = payload
        }
    }
})

export default HistorySlice.reducer